import { render, staticRenderFns } from "./checkout-form.vue?vue&type=template&id=0cdb1fab&scoped=true&"
import script from "./checkout-form.vue?vue&type=script&lang=js&"
export * from "./checkout-form.vue?vue&type=script&lang=js&"
import style0 from "./checkout-form.vue?vue&type=style&index=0&id=0cdb1fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb1fab",
  null
  
)

export default component.exports